// 🔧 organization_health_panel.js
// ✅ Purpose: Displays Organization Health summary
// ✅ Features:
// - Health status
// - Health score
// - Warning count
// - Error count
// - Future-ready for Organization Engine Health
//
// ✅ Notes:
// - Presentation only
// - Future versions will consume Organization Engine Health APIs

import React from "react";

const OrganizationHealthPanel = ({
  organization,
}) => {

  const healthScore =
    organization.healthScore ?? "—";

  const warningCount =
    organization.warningCount ?? 0;

  const errorCount =
    organization.errorCount ?? 0;

  const healthStatus =
    organization.healthStatus ??
    "Unknown";

  return (

    <div className="card shadow-sm mb-3">

      <div className="card-header bg-white">

        <strong>

          Organization Health

        </strong>

      </div>

      <div className="card-body">

        <div className="row g-4 align-items-center">

          <div className="col-lg-3 text-center">

            <div
              className={`display-5 fw-bold ${
                organization.healthScore >= 90
                  ? "text-success"
                  : organization.healthScore >= 70
                    ? "text-warning"
                    : "text-danger"
              }`}
            >

              {organization.healthScore ?? 0}%

            </div>

            <div className="text-muted">

              Overall Health

            </div>

          </div>

          <div className="col-lg-9">

            <div className="row g-3">

              <div className="col-md-4">

                <div className="card bg-light h-100">

                  <div className="card-body">

                    <div className="small text-muted">

                      Status

                    </div>

                    <div className="fw-bold">

                      {organization.healthStatus}

                    </div>

                  </div>

                </div>

              </div>

              <div className="col-md-4">

                <div className="card bg-light h-100">

                  <div className="card-body">

                    <div className="small text-muted">

                      Warnings

                    </div>

                    <div className="fw-bold">

                      {organization.warningCount}

                    </div>

                  </div>

                </div>

              </div>

              <div className="col-md-4">

                <div className="card bg-light h-100">

                  <div className="card-body">

                    <div className="small text-muted">

                      Errors

                    </div>

                    <div className="fw-bold">

                      {organization.errorCount}

                    </div>

                  </div>

                </div>

              </div>

            </div>

            <div className="progress mt-4">

              <div
                className={`progress-bar ${
                  organization.healthScore >= 90
                    ? "bg-success"
                    : organization.healthScore >= 70
                      ? "bg-warning"
                      : "bg-danger"
                }`}
                role="progressbar"
                style={{
                  width: `${organization.healthScore ?? 0}%`,
                }}
              />

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default OrganizationHealthPanel;